/** This file is auto generated by convertSvgToJsx.ts */

import icon from './dnb/home'
export default icon
